export default __webpack_public_path__ + "static/media/black-color-palette.cd99d271.png";